export const SET_FIELDS = 'SET_FIELDS';
export const SET_FIELD = 'SET_FIELD';
export const ADD_FIELD = 'ADD_FIELD';
export const UPDATE_FIELD = 'UPDATE_FIELD';
export const REMOVE_FIELD = 'REMOVE_FIELD';
export const CLEAR_FIELD = 'CLEAR_FIELD';
export const CLEAR_FIELDS = 'CLEAR_FIELDS';
